export const ApplePayPreview = ({icons, settings}) => {
    return (
        <div
            className={`applepay-block-editor ${settings.style}`}
            style={{
                maxHeight: '40px',
                backgroundColor: getBgColor(settings.style),
                borderRadius: '4px',
                ...(settings.style === 'white-outline' && {
                    border: '1px solid #000'
                })
            }}>
            <img
                src={getIcon(settings.style, icons)}
                style={{
                    width: '100%',
                    height: '40px',
                    objectFit: 'contain'
                }}/>
        </div>
    )
}

const getIcon = (style, icons) => {
    switch (style) {
        case 'black':
            return icons.black;
        default:
            return icons.white;
    }
}

const getBgColor = (style) => {
    switch (style) {
        case 'black':
            return '#000';
        default:
            return '#fff';
    }
}

export default ApplePayPreview;